class ArticleProjects extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    this.progress = this.querySelector('[data-progress]');
    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.scrollBy(-1));
    this.next?.addEventListener('click', () => this.scrollBy(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.update();
  }

  scrollBy(direction) {
    const card = this.track.querySelector('.article-projects__card');
    const amount = (card?.offsetWidth || 350) + 24;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const max = Math.max(scrollWidth - clientWidth, 1);
    const ratio = Math.min(Math.max(scrollLeft / max, 0), 1);
    if (this.progress) this.progress.style.width = `${Math.max(ratio, 0.15) * 100}%`;
    this.prev?.toggleAttribute('disabled', scrollLeft <= 8);
    this.next?.toggleAttribute('disabled', scrollLeft >= max - 8);
  }
}

if (!customElements.get('article-projects')) {
  customElements.define('article-projects', ArticleProjects);
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-copy-link]');
  if (!button) return;
  const url = button.getAttribute('data-copy-link');
  try {
    await navigator.clipboard.writeText(url);
    button.setAttribute('data-copied', 'true');
    setTimeout(() => button.removeAttribute('data-copied'), 1500);
  } catch (error) {
    window.prompt('Copy this link', url);
  }
});
